import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export type Crumb = { label: string; to?: string };

/** A horizontal breadcrumb trail. The last item is the current page; earlier
 * items with a `to` are links back up the hierarchy. */
export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-3 flex min-w-0 items-center gap-1.5 text-sm text-fg-muted">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <Fragment key={i}>
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0 text-fg-subtle" />}
            {last ? (
              <span className="truncate font-medium text-fg">{item.label}</span>
            ) : item.to ? (
              <Link to={item.to} className="truncate hover:text-fg">
                {item.label}
              </Link>
            ) : (
              <span className="truncate">{item.label}</span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
